module.exports = __webpack_public_path__ + "img/33.8.TSS.c378a34d.png";